import { Navigate, Route, Routes } from 'react-router-dom';
import { Marco } from './navegacion/Marco';
import { useSesion } from './sesion/Sesion';
import { Cargando } from './comun/componentes';
import { Ingreso } from './paginas/Ingreso';
import { Inicio } from './paginas/Inicio';
import { Pacientes } from './paginas/Pacientes';
import { FichaPaciente } from './paginas/FichaPaciente';
import { Agenda } from './paginas/Agenda';
import { Tratamientos } from './paginas/Tratamientos';
import { Finanzas } from './paginas/Finanzas';
import { Clinica } from './paginas/Clinica';
import { Seguimientos } from './paginas/Seguimientos';
import { Administracion } from './paginas/Administracion';

/**
 * Rutas de la aplicación. Los módulos con secciones las llevan en la URL (`/finanzas/caja`)
 * para que una pantalla se pueda compartir por enlace y el botón «atrás» funcione.
 */
export function App() {
  const { usuario, cargando } = useSesion();

  if (cargando) {
    return (
      <div className="grid min-h-dvh place-items-center bg-papel-100">
        <Cargando que="la sesión" />
      </div>
    );
  }

  if (!usuario) {
    return <Ingreso />;
  }

  return (
    <Routes>
      <Route element={<Marco />}>
        <Route index element={<Inicio />} />
        <Route path="pacientes" element={<Pacientes />} />
        <Route path="pacientes/:id" element={<FichaPaciente />} />
        <Route path="agenda" element={<Agenda />} />
        <Route path="tratamientos" element={<Tratamientos />} />
        <Route path="finanzas" element={<Navigate to="/finanzas/caja" replace />} />
        <Route path="finanzas/:seccion" element={<Finanzas />} />
        <Route path="clinica" element={<Navigate to="/clinica/inventario" replace />} />
        <Route path="clinica/:seccion" element={<Clinica />} />
        <Route path="seguimientos" element={<Seguimientos />} />
        <Route path="administracion" element={<Navigate to="/administracion/usuarios" replace />} />
        <Route path="administracion/:seccion" element={<Administracion />} />
        <Route path="*" element={<NoEncontrada />} />
      </Route>
    </Routes>
  );
}

function NoEncontrada() {
  return (
    <div className="panel px-4 py-12 text-center">
      <p className="text-lg font-semibold text-tinta-900">Esa pantalla no existe</p>
      <p className="mt-1 text-sm text-tinta-500">
        Probá con alguno de los ocho módulos del menú.
      </p>
    </div>
  );
}
